export default __webpack_public_path__ + "static/media/teamwork.708e16f2.svg";